// extracted by mini-css-extract-plugin
export var BreadcrumbList = "BreadcrumbList-module--BreadcrumbList--QRQ9J";